import React from 'react';
import classNames from 'classnames/bind';

import iconstyle from './icon.pcss';
import luxeiconstyle from './luxeIcon.pcss';

const cx = classNames.bind(iconstyle);
const luxecx = classNames.bind(luxeiconstyle);

export type FontWeight = 'normal' | 'bold';
export interface IconStyle {
  fontSize?: string;
  color?: string;
  fontWeight?: FontWeight;
  padding?: string;
}

export interface IconProps {
  id?: string;
  icon?: string;
  styles?: IconStyle;
  iconClass?: string;
  count?: number;
  onClick?: () => void;
  ariaLabel?: string;
  ariaHidden?:boolean;
}

const Icon = (props: IconProps): JSX.Element => {
  const { id, icon, styles, count = 0, iconClass, onClick, ariaLabel, ariaHidden } = props;
  // TODO: improve logic for sis
  const classnames = icon?.includes('luxe')
    ? luxecx(icon, iconClass, 'luxegeneral', { counter: count > 0 })
    : cx(icon, iconClass, 'general', { counter: count > 0 });
  return (
    <div
      role="button"
      id={id}
      className={classnames}
      style={styles}
      data-after={count}
      onClick={onClick}
      aria-label={ariaLabel}
      {...(ariaHidden !== undefined ? { "aria-hidden": ariaHidden ? "true" : "false" } : {})} 
      {...(ariaHidden ? {} : { tabIndex: 0 })}
    />
  );
};

Icon.defaultProps = {
  icon: 'cross',
  styles: {},
  iconClass: '',
  count: 0
};

export default Icon;
